import styled from "styled-components";

import { colors } from "constants/theme";

const TableBody = styled.tbody`
  color: ${colors.text};
`;

export default TableBody;
